<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-select
                v-model="where.user_id"
                multiple
                clearable
                filterable
                allow-create
                class="ele-block"
                placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户订单">
              <el-input clearable v-model="where.merchantOrderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.channel_id" placeholder="请选择">
                <el-option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="通道订单">
              <el-input clearable v-model="where.pay_trade_no" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="收款名称">
              <el-input clearable v-model="where.inPayerName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="交易状态">
              <el-select clearable class="ele-block" v-model="where.order_status" placeholder="请选择">
                <el-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="10">
            <el-form-item label="账变状态">
              <el-select clearable class="ele-block" v-model="where.is_balance" placeholder="请选择">
                <el-option
                  v-for="item in isBalanceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="24">
            <el-form-item label="选择时间">
              <div class="outorder-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="applyTimeQuick">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="timeQuick = ''" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" class="ele-btn-icon" @click="onExportClick"
                v-if="permission.includes('sys:outorder:export')">导出</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="startAutoRefresh">开启</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="small" class="ele-btn-icon" @click="stopAutoRefresh">关闭</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="outorder-stat-bar">
        <span>订单总量: {{ dataList.total_count }}</span>
        <span>成功数量: {{ dataList.success_count }}</span>
        <span>失败数量: {{ dataList.fail_count }}</span>
        <span>订单总金额: {{ dataList.total_amount }}</span>
        <span>成功金额: {{ dataList.success_amount }}</span>
        <span>失败金额: {{ dataList.fail_amount }}</span>
        <span>成功率: {{ dataList.success_rate }}</span>
        <span>手续费: {{ dataList.mch_rate_total }} 元</span>
        <span>订单费率: {{ dataList.mch_fees_total }} 元</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="tableWhere"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 330px)"
        class="outorder-table"
        @done="onTableDone">
        <template slot="toolbar">
          <el-button
            size="small"
            type="warning"
            icon="el-icon-refresh"
            class="ele-btn-icon"
            :loading="busyKey === 'init'"
            :disabled="!!busyKey && busyKey !== 'init'"
            @click="initData"
            v-if="permission.includes('sys:outorder:edit')">
            清空
          </el-button>
        </template>
        <template slot="userOrderInfo" slot-scope="{ row }">
          <div>
            <div>商户昵称: {{ row.nickname || row.username }}</div>
            <div>
              商户订单:
              <span
                v-if="row.merchantOrderNo"
                class="copyable-text"
                title="点击复制"
                @click="copyText(row.merchantOrderNo)">{{ formatShortOrderNo(row.merchantOrderNo) }}</span>
            </div>
          </div>
        </template>
        <template slot="requestExpireInfo" slot-scope="{ row }">
          <div>
            <div>
              交易金额: {{ row.paymentAmount }}<template v-if="row.paymentCurrency">({{ row.paymentCurrency }})</template>
            </div>
            <div>请求时间: {{ row.timeStart }}</div>
          </div>
        </template>
        <template slot="channelPayTypeInfo" slot-scope="{ row }">
          <div>
            <div>通道名称: {{ row.channel_display_name || row.up_channel_name }}</div>
            <div>通道类型: {{ row.channel_type_name || row.channel_name }}</div>
          </div>
        </template>
        <template slot="orderNoInfo" slot-scope="{ row }">
          <div>
            <div>
              系统订单:
              <span
                v-if="row.orderNo"
                class="copyable-text"
                title="点击复制"
                @click="copyText(row.orderNo)">{{ formatShortOrderNo(row.orderNo) }}</span>
            </div>
            <div>
              通道订单:
              <span
                v-if="row.pay_trade_no"
                class="copyable-text"
                title="点击复制"
                @click="copyText(row.pay_trade_no)">{{ formatShortOrderNo(row.pay_trade_no) }}</span>
            </div>
          </div>
        </template>
        <template slot="payerInfo" slot-scope="{ row }">
          <div>
            <div>收款姓名: {{ row.payerName }}</div>
            <div>
              收款账号: {{ formatMaskedAccount(row.payerAccount, row.payerBankName) }}
              <el-button
                v-if="row.payerName || row.payerBankName || row.payerAccount"
                type="text"
                icon="el-icon-document"
                class="copy-icon-btn"
                @click.stop="copyFields(row.payerName, row.payerBankName, row.payerAccount)" />
            </div>
          </div>
        </template>
        <template slot="amountInfo" slot-scope="{ row }">
          <div v-if="row.outPayItems && row.outPayItems.length > 1">
            <el-button type="text" @click.stop="openOutPayItems(row)">查看</el-button>
          </div>
          <div v-else-if="row.outPayerName || row.outPayerBankName || row.outPayerAccount">
            <div>出款姓名: {{ row.outPayerName }}</div>
            <div>
              出款账号: {{ formatMaskedAccount(row.outPayerAccount, row.outPayerBankName) }}
              <el-button
                type="text"
                icon="el-icon-document"
                class="copy-icon-btn"
                @click.stop="copyFields(row.outPayerName, row.outPayerBankName, row.outPayerAccount)" />
            </div>
          </div>
        </template>
        <template slot="feeInfo" slot-scope="{ row }">
          <div>
            <div>手续费用: {{ row.mch_rate }}</div>
            <div>交易费率: {{ row.mch_fees }}</div>
          </div>
        </template>
        <template slot="orderTimeInfo" slot-scope="{ row }">
          <div>
            <div>创建时间: {{ formatTime(row.create_time) }}</div>
            <div>更新时间: {{ formatTime(row.update_time) }}</div>
          </div>
        </template>
        <template slot="orderTradeStatus" slot-scope="{ row }">
          <div>
            <div>
              订单状态:
              <dict-tag dict-code="out_order_flag" :value="orderFlagValue(row)" :show-value="false" text-only />
            </div>
            <div>
              交易状态:
              <dict-tag dict-code="out_order_status" :value="row.order_status" :show-value="false" text-only />
            </div>
          </div>
        </template>
        <template slot="callbackBalanceStatus" slot-scope="{ row }">
          <div>
            <div>
              回调状态:
              <dict-tag
                dict-code="order_related_status"
                field="callback_status"
                :value="row.callback_status"
                :show-value="false"
                text-only />
            </div>
            <div>
              账变状态:
              <dict-tag
                dict-code="order_related_status"
                field="is_balance"
                :value="row.is_balance"
                :show-value="false"
                text-only />
            </div>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="outorder-action" @click.stop>
            <template v-if="canOperate(row)">
              <el-button type="success" size="mini" class="ele-btn-icon" @click="openSuccess(row)"
                v-if="permission.includes('sys:outorder:edit')">成功</el-button>
              <el-button type="primary" size="mini" class="ele-btn-icon" @click="openHandle(row)"
                v-if="permission.includes('sys:outorder:handle')">派单</el-button>
              <el-button type="danger" size="mini" class="ele-btn-icon" @click="openFail(row)"
                v-if="permission.includes('sys:outorder:edit')">失败</el-button>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" class="ele-btn-icon" @click="openDetail(row)">详情</el-button>
              <el-button
                v-if="canSettleDispatched(row) && permission.includes('sys:outorder:edit')"
                type="success"
                size="mini"
                class="ele-btn-icon"
                @click="openSuccess(row)">成功</el-button>
              <el-button
                v-if="canSettleDispatched(row) && permission.includes('sys:outorder:edit')"
                type="danger"
                size="mini"
                class="ele-btn-icon"
                @click="openFail(row)">失败</el-button>
              <el-button
                v-if="canResend(row) && permission.includes('sys:outorder:callback')"
                type="primary"
                size="mini"
                class="ele-btn-icon"
                :loading="busyKey === `push:${row.id}`"
                :disabled="!!busyKey"
                @click="pushOrder(row)">重发</el-button>
              <el-button
                v-if="canCancel(row) && permission.includes('sys:outorder:cancel')"
                type="danger"
                size="mini"
                class="ele-btn-icon"
                :loading="busyKey === `cancel:${row.id}`"
                :disabled="!!busyKey"
                @click="cancelOrder(row)">撤销</el-button>
            </template>
          </div>
        </template>
      </ele-pro-table>
    </el-card>

    <tuis-edit :data="failOrder" :visible.sync="showFail" @done="reload" />
    <show :order-id="detailId" :visible.sync="showDetail" />
    <show-over :data="successOrder" :visible.sync="showSuccess" @done="reload" />
    <handle-dialog :visible.sync="showHandle" :order="handleOrder" @done="reload" />
    <export-progress-dialog ref="exportDialog" biz="outorder" title="导出代付订单" />

    <el-dialog
      title="出款明细"
      :visible.sync="showOutPayItems"
      width="520px"
      append-to-body
      :lock-scroll="false"
      destroy-on-close
      custom-class="ele-dialog-form">
      <el-table :data="outPayItems" size="small" border>
        <el-table-column label="付款卡" min-width="280" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ [row.account_name, row.bank_name, row.account_number].filter(Boolean).join('_') }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="处理金额" width="120" align="right" />
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="showOutPayItems = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getDictData, loadDictOptions } from '@/utils/dict';
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';
import TuisEdit from './tuis-edit.vue';
import Show from './show.vue';
import ShowOver from './show_over.vue';
import HandleDialog from './handle-dialog.vue';

const EMPTY_STATS = {
  total_count: 0,
  success_count: 0,
  fail_count: 0,
  total_amount: '0',
  success_amount: '0',
  fail_amount: '0',
  success_rate: '0%',
  mch_rate_total: '0',
  mch_fees_total: '0'
};

const CONFIRM_OPTS = {
  type: 'warning',
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  lockScroll: false,
  closeOnClickModal: false
};

const COLUMNS = [
  { columnKey: 'id', prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
  { columnKey: 'userOrderInfo', label: '昵称/商户订单', prop: 'userOrderInfo', showOverflowTooltip: false, minWidth: 200, align: 'left', slot: 'userOrderInfo' },
  { columnKey: 'requestExpireInfo', label: '金额/时间', prop: 'requestExpireInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'requestExpireInfo' },
  { columnKey: 'channelPayTypeInfo', label: '通道/通道类型', prop: 'channelPayTypeInfo', showOverflowTooltip: false, minWidth: 180, align: 'left', slot: 'channelPayTypeInfo' },
  { columnKey: 'orderNoInfo', label: '系统/通道订单', prop: 'orderNoInfo', showOverflowTooltip: false, minWidth: 200, align: 'left', slot: 'orderNoInfo' },
  { columnKey: 'payerInfo', label: '收款信息', prop: 'payerInfo', showOverflowTooltip: false, minWidth: 240, align: 'left', slot: 'payerInfo' },
  { columnKey: 'amountInfo', label: '出款信息', prop: 'amountInfo', showOverflowTooltip: false, minWidth: 240, align: 'left', slot: 'amountInfo' },
  { columnKey: 'feeInfo', label: '费率信息', prop: 'feeInfo', showOverflowTooltip: false, minWidth: 150, align: 'left', slot: 'feeInfo' },
  { columnKey: 'orderTimeInfo', label: '创建/更新时间', prop: 'orderTimeInfo', showOverflowTooltip: false, minWidth: 220, align: 'left', slot: 'orderTimeInfo' },
  { columnKey: 'orderTradeStatus', label: '订单/交易状态', prop: 'orderTradeStatus', showOverflowTooltip: false, minWidth: 160, align: 'left', slot: 'orderTradeStatus', fixed: 'right' },
  { columnKey: 'callbackBalanceStatus', label: '回调/账变状态', prop: 'callbackBalanceStatus', showOverflowTooltip: false, minWidth: 150, align: 'left', slot: 'callbackBalanceStatus', fixed: 'right' },
  { columnKey: 'action', label: '操作', width: 220, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
];

function pad2(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

function formatDateTime(date) {
  const d = date instanceof Date ? date : new Date(date);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}

function getTimeRange(key) {
  const now = new Date();
  const start = new Date(now);
  const end = new Date(now);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 0);

  if (key === 'today') return [formatDateTime(start), formatDateTime(end)];
  if (key === 'yesterday') {
    start.setDate(start.getDate() - 1);
    end.setDate(end.getDate() - 1);
    return [formatDateTime(start), formatDateTime(end)];
  }
  if (key === 'week') {
    const day = start.getDay() || 7;
    start.setDate(start.getDate() - day + 1);
    return [formatDateTime(start), formatDateTime(end)];
  }
  if (key === 'month') {
    start.setDate(1);
    return [formatDateTime(start), formatDateTime(end)];
  }
  if (key === 'lastMonth') {
    start.setMonth(start.getMonth() - 1, 1);
    end.setDate(0);
    end.setHours(23, 59, 59, 0);
    return [formatDateTime(start), formatDateTime(end)];
  }
  if (key === 'days30') {
    start.setDate(start.getDate() - 29);
    return [formatDateTime(start), formatDateTime(end)];
  }
  return null;
}

export default {
  name: 'Outorder',
  components: {
    TuisEdit,
    Show,
    ShowOver,
    HandleDialog,
    ExportProgressDialog
  },
  data() {
    return {
      url: '/Outorder/index',
      columns: COLUMNS,
      where: { user_id: [], time: getTimeRange('today') },
      timeQuick: 'today',
      intervalId: null,
      busyKey: '',
      failOrder: null,
      showFail: false,
      detailId: null,
      showDetail: false,
      successOrder: null,
      showSuccess: false,
      showHandle: false,
      handleOrder: null,
      showOutPayItems: false,
      outPayItems: [],
      channelList: [],
      userList: [],
      dataList: { ...EMPTY_STATS },
      orderStatusOptions: [],
      isBalanceOptions: [],
      knownOrderIds: {},
      orderWatchReady: false,
      beepAudio: null,
      unlockBeepHandler: null
    };
  },
  computed: {
    ...mapGetters(['permission']),
    tableWhere() {
      return this.buildSearchParams();
    },
    dialogOpen() {
      return this.showFail || this.showDetail || this.showSuccess || this.showHandle || this.showOutPayItems;
    }
  },
  mounted() {
    getDictData('order_related_status');
    getDictData('out_order_flag');
    loadDictOptions('out_order_status')
      .then((list) => { this.orderStatusOptions = list || []; })
      .catch((e) => this.$message.error(e.message));
    loadDictOptions('yes_no')
      .then((list) => { this.isBalanceOptions = list || []; })
      .catch((e) => this.$message.error(e.message));
    this.initBeepAudio();
    this.loadChannelList();
    this.loadUserList();
    this.loadStats();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
    this.teardownBeepAudio();
  },
  methods: {
    buildSearchParams() {
      const userId = this.where.user_id;
      return {
        ...this.where,
        user_id: Array.isArray(userId) ? userId.join(',') : userId
      };
    },
    initBeepAudio() {
      const audio = new Audio(`${process.env.BASE_URL || '/'}beep.mp3`);
      audio.preload = 'auto';
      this.beepAudio = audio;
      // 浏览器限制：需用户手势后才能出声
      this.unlockBeepHandler = () => {
        const a = this.beepAudio;
        if (!a) return;
        const p = a.play();
        if (p && typeof p.then === 'function') {
          p.then(() => {
            a.pause();
            a.currentTime = 0;
          }).catch(() => {});
        }
        this.teardownBeepUnlock();
      };
      document.addEventListener('click', this.unlockBeepHandler, { once: true });
      document.addEventListener('touchstart', this.unlockBeepHandler, { once: true });
    },
    teardownBeepUnlock() {
      if (!this.unlockBeepHandler) return;
      document.removeEventListener('click', this.unlockBeepHandler);
      document.removeEventListener('touchstart', this.unlockBeepHandler);
      this.unlockBeepHandler = null;
    },
    teardownBeepAudio() {
      this.teardownBeepUnlock();
      if (this.beepAudio) {
        this.beepAudio.pause();
        this.beepAudio = null;
      }
    },
    playNewOrderBeep() {
      const audio = this.beepAudio;
      if (!audio) return;
      try {
        audio.currentTime = 0;
        const p = audio.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {});
        }
      } catch (e) {
        // ignore autoplay block
      }
    },
    rememberOrderIds(rows) {
      (rows || []).forEach((row) => {
        const id = Number(row && row.id);
        if (id > 0) this.knownOrderIds[id] = 1;
      });
    },
    hasNewPendingOrders(rows) {
      return (rows || []).some((row) => {
        const id = Number(row && row.id);
        return id > 0 && Number(row.order_status) === 0 && !this.knownOrderIds[id];
      });
    },
    onTableDone(result) {
      const rows = (result && result.data) || [];
      if (this.orderWatchReady && this.hasNewPendingOrders(rows)) {
        this.playNewOrderBeep();
      }
      this.rememberOrderIds(rows);
      this.orderWatchReady = true;
      const table = this.$refs.table;
      if (table && table.doLayout) {
        this.$nextTick(() => table.doLayout());
      }
    },
    statusOf(row) {
      return Number(row && row.order_status);
    },
    canOperate(row) {
      return this.statusOf(row) === 0 && !Number(row.is_dispatched);
    },
    // 已派单给机器人后仍可标记成功/失败
    canSettleDispatched(row) {
      return this.statusOf(row) === 0 && !!Number(row.is_dispatched);
    },
    canResend(row) {
      const status = this.statusOf(row);
      return status !== 0 && status !== 3 && Number(row.callback_status) === 2;
    },
    canCancel(row) {
      return this.statusOf(row) === 1;
    },
    formatMaskedAccount(account, bankName) {
      if (!account) return '';
      const text = String(account);
      const masked = text.length >= 7 ? `${text.slice(0, 3)}****${text.slice(-4)}` : text;
      return bankName ? `${masked}(${bankName})` : masked;
    },
    formatShortOrderNo(orderNo) {
      if (!orderNo) return '';
      const text = String(orderNo);
      return text.length <= 14 ? text : `${text.slice(0, 6)}...${text.slice(-6)}`;
    },
    formatTime(value) {
      if (!value) return '';
      return typeof value === 'number' || /^\d+$/.test(String(value))
        ? this.$util.toDateString(value)
        : value;
    },
    orderFlagValue(row) {
      const status = this.statusOf(row);
      if (status === 4) return 4;
      if (status === 0 && Number(row.is_dispatched)) return 1;
      return 0;
    },
    copyText(text) {
      if (!text) return;
      const value = String(text);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(() => {
          this.$message.success('复制成功');
        }).catch(() => {
          this.copyByTextarea(value);
        });
        return;
      }
      this.copyByTextarea(value);
    },
    copyByTextarea(value) {
      const el = document.createElement('textarea');
      el.value = value;
      el.setAttribute('readonly', 'readonly');
      el.style.cssText = 'position:fixed;left:-9999px;top:0';
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (e) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(el);
    },
    copyFields(...parts) {
      const text = parts.filter(Boolean).join('\n');
      if (!text) {
        this.$message.warning('没有可复制的内容');
        return;
      }
      this.copyText(text);
    },
    openOutPayItems(row) {
      this.outPayItems = Array.isArray(row.outPayItems) ? row.outPayItems : [];
      this.showOutPayItems = true;
    },
    applyTimeQuick(key) {
      this.timeQuick = key;
      this.where.time = getTimeRange(key);
      this.reload();
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload({ where: this.buildSearchParams() });
      }
      this.loadStats();
    },
    reset() {
      this.where = { user_id: [], time: getTimeRange('today') };
      this.timeQuick = 'today';
      this.reload();
    },
    openDetail(row) {
      this.detailId = row.id;
      this.showDetail = true;
    },
    openSuccess(row) {
      this.successOrder = row;
      this.showSuccess = true;
    },
    openHandle(row) {
      this.handleOrder = {
        id: row.id,
        orderNo: row.orderNo,
        paymentAmount: row.paymentAmount
      };
      this.showHandle = true;
    },
    openFail(row) {
      this.failOrder = row;
      this.showFail = true;
    },
    pushOrder(row) {
      this.confirmAction('重发', '确认重发该订单？', `push:${row.id}`, () =>
        this.$http.post('/Outorder/callBackOne', { id: row.id })
      );
    },
    cancelOrder(row) {
      this.confirmAction('撤销', '确认撤销该订单？', `cancel:${row.id}`, () =>
        this.$http.post('/Outorder/cancellOrder', { id: row.id })
      );
    },
    initData() {
      this.confirmAction('提示', '初始化将清空全部代付订单且不可恢复，确定继续？', 'init', () =>
        this.$http.post('/Outorder/initData')
      );
    },
    confirmAction(title, message, busyKey, request) {
      if (this.busyKey) return;
      this.$confirm(message, title, CONFIRM_OPTS)
        .then(() => this.runAction(busyKey, request))
        .catch(() => {});
    },
    runAction(busyKey, request) {
      if (this.busyKey) return;
      this.busyKey = busyKey;
      request()
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        })
        .then(() => {
          this.busyKey = '';
        });
    },
    startAutoRefresh() {
      if (this.intervalId != null) return;
      this.intervalId = setInterval(() => {
        if (this.busyKey || this.dialogOpen) return;
        this.reload();
      }, 10000);
    },
    stopAutoRefresh() {
      if (this.intervalId == null) return;
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    onExportClick() {
      this.$refs.exportDialog.start(this.buildSearchParams());
    },
    loadStats() {
      this.$http
        .post('/Outorder/getInorderCount', this.buildSearchParams())
        .then((res) => {
          if (res.data.code === 0) {
            this.dataList = res.data.data || { ...EMPTY_STATS };
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch((e) => this.$message.error(e.message));
    },
    loadChannelList() {
      this.$http
        .post('/ChannelColumnOut/getchannelList', { type: 2 })
        .then((res) => {
          if (res.data && res.data.code === 0) {
            this.channelList = res.data.data || [];
          }
        })
        .catch(() => {});
    },
    loadUserList() {
      this.$http
        .get('/UserBalancesRecords/getUserList')
        .then((res) => {
          if (res.data && res.data.code === 0) {
            this.userList = res.data.data || [];
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.outorder-stat-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;
  margin-bottom: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.outorder-table ::v-deep .el-table td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.outorder-table ::v-deep .el-table td > .cell {
  white-space: normal;
  line-height: 1.55;
}

.outorder-table ::v-deep .copy-icon-btn {
  padding: 0;
  margin-left: 4px;
  height: auto;
  min-height: 0;
  line-height: inherit;
  vertical-align: baseline;
  border: none;
}

.outorder-table ::v-deep .copy-icon-btn i {
  font-size: inherit;
}

.outorder-action {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.outorder-action .el-button + .el-button {
  margin-left: 0;
}

.copyable-text {
  color: #409eff;
  cursor: pointer;
}

.copyable-text:hover {
  color: #66b1ff;
}

.outorder-time-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
</style>
